import { PiCheckCircleBold, PiClockBold } from 'react-icons/pi';
import { FileTypeIcon } from './FileGridCard';
import type { PloomesFileItem } from './types';

type Props = {
    file: PloomesFileItem;
    onClick: () => void;
};

export default function FileListRow({ file, onClick }: Props) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="flex w-full items-center gap-4 border-b border-gray-100 px-4 py-3 text-left transition last:border-b-0 hover:bg-gray-50 dark:border-gray-700/50 dark:hover:bg-gray-800/60"
        >
            {/* Ícone / thumbnail */}
            <div className="flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800">
                {file.is_image && file.access_url ? (
                    <img src={file.access_url} alt="" className="size-full object-cover" loading="lazy" />
                ) : (
                    <FileTypeIcon file={file} />
                )}
            </div>

            {/* Nome + categoria */}
            <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-gray-900 dark:text-gray-100">
                    {file.display_name}
                </p>
                <p className="truncate text-xs text-gray-500 dark:text-gray-400">
                    {[file.category_label, file.deal?.contact_name].filter(Boolean).join(' · ') || '—'}
                </p>
            </div>

            <span className="hidden shrink-0 text-xs text-gray-500 dark:text-gray-400 sm:block">
                {file.readable_size ?? '—'}
            </span>
            <span className="hidden shrink-0 text-xs text-gray-500 dark:text-gray-400 md:block">
                {file.ploomes_created_at
                    ? new Date(file.ploomes_created_at).toLocaleDateString('pt-BR')
                    : '—'}
            </span>
            <span className="shrink-0">
                {file.is_validated
                    ? <PiCheckCircleBold className="size-5 text-emerald-500" />
                    : <PiClockBold className="size-5 text-amber-500" />
                }
            </span>
        </button>
    );
}
